import { createSelector } from 'reselect';
import { getTr } from '../../../Report/Report.selectors';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import store from '../../../../stores/redux';

const computeTotalsFromRows = (rows) => {
    if (!rows || rows.length === 0) return {};

    const totals = {};
    const keys = Object.keys(rows[0] || {});

    keys.forEach((key) => {
        let sum = 0;
        let hasNumeric = false;
        for (let i = 0; i < rows.length; i++) {
            const value = rows[i][key];
            if (typeof value === 'number' && Number.isFinite(value)) {
                sum += value;
                hasNumeric = true;
            }
        }
        if (hasNumeric) {
            totals[key] = sum;
        } else if (key === 'GroupBy') {
            totals[key] = 'Total:';
        } else {
            totals[key] = '';
        }
    });

    if (!('GroupBy' in totals)) {
        totals.GroupBy = 'Total:';
    }

    return totals;
};

const reportUtils = ReportComponent.utils;

const rows = (state) => state.statistics.data.rows;
const totals = (state) => state.statistics.data.totals;
const parameters = (state) => state.statistics.data.parameters;
const location = (state) => state.routingCompat;
const offers = (state) => state.offers.list;
const goals = (state) => state.goals.list;
const links = (state) => state.links.list;
const regions = (state) => state.regions.list;
const report = (state) => state.serverStorage.store.report;
let oldRows = rows(store.getState());

export const mainSelector = createSelector(
    rows,
    totals,
    parameters,
    offers,
    goals,
    links,
    regions,
    (rows = [], totals = {}, parameters = {}) => {
        let data = '';

        parameters.isChange = rows !== oldRows;
        parameters.isHtml = false;
        oldRows = rows;

        rows.forEach((item) => {
            data += getTr(item, parameters);
        });

        if (rows.length > 0) {
            if (Object.keys(totals).length) {
                const totalsLabeled = { ...totals, GroupBy: 'Total:' };
                data += getTr(totalsLabeled, parameters, true);
            } else {
                const computedTotals = computeTotalsFromRows(rows);
                if (Object.keys(computedTotals).length) {
                    data += getTr(computedTotals, parameters, true);
                }
            }
        }

        return data;
    }
);

export const getHeaderName = createSelector(
    parameters,
    location,
    report,
    (parameters = {}, location = {}, report) => {
        reportUtils.setKeyGroupBy(parameters.group_by || location?.query?.groupBy);
        let headerNames = reportUtils.getMultiLevelHeaderNames();

        const urlParams = new URLSearchParams(location?.search);
        const urlMetrics = urlParams.get('metrics');
        const metrics = urlMetrics || report?.metrics || reportUtils.getDefStrMetric();

        let visibleKeysMetric;
        if (Array.isArray(metrics)) {
            visibleKeysMetric = metrics;
        } else {
            visibleKeysMetric = reportUtils.getKeysMetric(metrics);
        }

        reportUtils.updateVisible(headerNames, visibleKeysMetric);

        return headerNames;
    }
);

export const getMetrics = createSelector(
    location,
    report,
    (location, report) => {
        const urlParams = new URLSearchParams(location?.search);
        const urlMetrics = urlParams.get('metrics');
        return urlMetrics || report?.metrics || reportUtils.getDefStrMetric();
    }
);

export const getKeysMetric = createSelector(
    location,
    report,
    (location, report) => {
        const urlParams = new URLSearchParams(location?.search);
        const urlMetrics = urlParams.get('metrics');
        const metrics = urlMetrics || report?.metrics || reportUtils.getDefStrMetric();

        if (Array.isArray(metrics)) {
            return metrics;
        } else {
            return reportUtils.getKeysMetric(metrics);
        }
    }
);
